import { useContext } from 'react'
import { BasenameContext } from './context'

/**
 * Prefixes an in-app path with the tracker's mount-point basename so links
 * resolve to the right place in BOTH shells (free SPA at root, embedded under
 * /tracker). `<Link to={href('/history')}>` -> '/history' free, '/tracker/history'
 * embedded. The single seam for declarative-link targets (spec §6, §15 invariant 2).
 */
export function useTrackerHref(): (to: string) => string {
  const basename = useContext(BasenameContext)

  return (to: string) => {
    if (!basename) return to
    // Root link ('/') -> the mount point itself.
    if (to === '/') return basename

    return `${basename}${to.startsWith('/') ? to : `/${to}`}`
  }
}
